import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation unblockProcessingUser($username: String!, $comment: String) {
      blockProcessingUser(
        username: $username
        isBlocked: false
        comment: $comment
      ) {
        success
      }
    }
  `,
  mutationName: "unblockProcessingUser",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/unblockProcessingUser.js